import { useMutation } from "@apollo/client/react";
import { ADD_CLIENT_EMAIL_CONNECTION } from "../../mutations/documentHandler/addClientEmailConnection";
import GET_ALL_UPLOAD_UNITS from "../../queries/documentHandler/getAllUploadUnits";

export const useAddClientEmailConnection = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: (error: any) => void;
}) => {
  const [addClientEmailConnection, { data, loading, error }] = useMutation(
    ADD_CLIENT_EMAIL_CONNECTION,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_ALL_UPLOAD_UNITS],
      awaitRefetchQueries: true,
    }
  );

  return { addClientEmailConnection, data, loading, error };
};
